
    // this file was auto generated by python script
    import Compass from './Compass';
    export default Compass;
    